import Axios from "axios";
import { decryptDocumentText, encryptAES } from "../helpers/encryptionHelper";

const instance = Axios.create({
  // .. where we make our configurations
  baseURL: process.env.REACT_APP_NODE_APIS_BASE_URL,
});

let windowWidth = window.innerWidth;
let windowHeight = window.innerHeight;

instance.defaults.headers.post["Content-Type"] = "application/json";
instance.defaults.headers["x-is-res-encrypted"] = true;

instance.interceptors.request.use(
  (config) => {
    let contentType =
      config["Content-Type"] ||
      config["content-type"] ||
      config.headers["Content-Type"] ||
      config.headers["content-type"];

    if (contentType === "multipart/form-data") {
      return config;
    }

    if (config.data && process.env.REACT_APP_ENV !== "dev") {
      const encryptedData = encryptAES(JSON.stringify(config.data));
      config.data = { payload: encryptedData };
      config.headers["x-is-req-encrypted"] = true;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    if (response.data?.data && response.data?.isEncrypted) {
      let decryptedResponse = decryptDocumentText(response.data.data);
      decryptedResponse = JSON.parse(decryptedResponse);
      response.data = decryptedResponse;
    }

    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Also add/ configure interceptors && all the other cool stuff
export default instance;
